var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "helpPage",
      attrs: {
        action: _vm.actionUrl,
        method: "post",
        name: "ssoForm",
        target: _vm.linkTarget,
        "accept-charset": "Shift_JIS"
      },
      on: { click: _vm.openFaq }
    },
    [
      _vm.ssoData
        ? _c("span", [
            _c("input", {
              attrs: { type: "hidden", name: "sso_auth_key" },
              domProps: { value: _vm.ssoData.ssoAuthKey }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "sso_mail" },
              domProps: { value: _vm.ssoData.ssoMail }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "sso_expired" },
              domProps: { value: _vm.ssoData.ssoExpired }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "sso_name" },
              domProps: { value: _vm.ssoData.ssoName }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "sso_group_id" },
              domProps: { value: _vm.ssoData.ssoGroupId }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "sso_chk" },
              domProps: { value: _vm.ssoData.ssoChk }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }